
import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import CompanyMixin from '@/_mixins/company'
import ProjectMixin from '@/_mixins/project'
import UserMixin from '@/_mixins/user'

import { isBoolean } from 'lodash'
import Filters from '../filters/filters.vue'
import Sorting from '@/views/Project/Observation/components/filters/sorting.vue'
import { formatObservationModuleFe } from '@/types/observation'

@Component({
    components: {
        Filters,
        Sorting,
    },
    mixins: [ObservationMixin, CompanyMixin, ProjectMixin, UserMixin],
})
export default class FilterPanel extends Mixins<MixinInterface>(
    ObservationMixin,
    CompanyMixin,
    ProjectMixin,
    UserMixin
) {
    @Prop() totalCount!: any

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    // USER SETTINGS
    loading = false

    get userSettings() {
        return this.project && this.project.relationships.userSettings.data
            ? this.$store.getters.projectUserSettings[
                  this.project.relationships.userSettings.data.id
              ]
            : this.group && this.group.relationships.userSettings.data
            ? this.$store.getters.groupUserSettings[this.group.relationships.userSettings.data.id]
            : null
    }

    // SEARCH TERMS
    get searchTerm() {
        return this.observationFilter.searchTerm
    }

    set searchTerm(val: string) {
        let obj = JSON.parse(JSON.stringify(this.observationFilter))
        obj.searchTerm = val
        this.$store.commit('observationFilter', obj)
    }

    // FILTERS
    filterCount = 0

    get observationFilter() {
        return this.$store.getters.observationFilter
    }

    set observationFilter(data: any) {
        this.$store.commit('observationFilter', data)
    }

    baseObservationFilter = {}

    inititateObservationFilter() {
        this.$store.commit('observationFilter', this.baseObservationFilter)
    }

    get hasStagedChangesFilter() {
        return JSON.stringify(this.observationFilter) != JSON.stringify(this.baseObservationFilter)
    }

    // SORTING
    get observationSort() {
        return this.$store.getters.observationSort
    }

    set observationSort(data: any) {
        this.$store.commit('observationSort', data)
    }

    baseObservationSort = {}

    inititateObservationSort() {
        this.$store.commit('observationSort', this.baseObservationSort)
    }

    get hasStagedChangesSort() {
        return JSON.stringify(this.observationSort) != JSON.stringify(this.baseObservationSort)
    }

    get hasSort() {
        let result = false
        Object.values(this.observationSort).map((item: any) => {
            if (!(item === null)) {
                result = true
            }
        })
        return result
    }

    // ME MODE
    get meMode() {
        return this.$store.getters.meMode
    }

    set meMode(val: boolean) {
        this.$store.commit('meMode', val)
    }

    baseMeMode = {}

    get meModeChanged() {
        return isBoolean(this.baseMeMode) ? this.meMode != this.baseMeMode : this.meMode
    }

    // FILTERS PANEL
    async saveChanges() {
        if (!this.userSettings) return null
        this.loading = true
        let json = this.userSettings.attributes.frontEndSettings
            ? JSON.parse(this.userSettings.attributes.frontEndSettings)
            : { observationModule: {} }
        if (!Object.prototype.hasOwnProperty.call(json, 'observationModule')) {
            json.observationModule = {}
        }

        json.observationModule.meMode = this.meMode
        json.observationModule.filter = this.observationFilter
        json.observationModule.sort = this.observationSort
        let data: any = {
            type: this.userSettings.type,
            id: this.userSettings.id,
            attributes: {
                frontEndSettings: JSON.stringify(json),
            },
        }
        if (this.project) {
            await this.patchProjectUserSettings(data).catch(() => {
                //
            })
        }
        if (this.group) {
            await this.patchtGroupUserSettings(data).catch(() => {
                //
            })
        }
        this.initBaseValues()

        this.loading = false
    }

    discardChanges() {
        this.initBaseValues()
        this.inititateObservationFilter()
        this.inititateObservationSort()
        this.$store.commit('meMode', this.baseMeMode)
    }

    initBaseValues() {
        const observationModuleFe = formatObservationModuleFe(
            this.lodash.cloneDeep(this.userSettings.attributes.frontEndSettings)
        )

        this.baseMeMode = this.lodash.cloneDeep(observationModuleFe.meMode)
        this.baseObservationFilter = this.lodash.cloneDeep(observationModuleFe.filter)
        this.baseObservationSort = this.lodash.cloneDeep(observationModuleFe.sort)
    }

    mounted() {
        this.initBaseValues()
    }
}
